import type { ApprovalAttribution, ApprovalNotes } from '@branditdev/mf-types'
import { Card, CardBody, CardHeader } from 'reactstrap'

const approvalAttributionFor = (order: ApprovalNotes['order']): ApprovalAttribution => {
  const approverName = [
    order.approved_by_admin_name,
    order.approved_by_admin_role ? `(${order.approved_by_admin_role})` : null
  ]
    .filter(Boolean)
    .join(' ')

  return {
    hasDetails: Boolean(order.approved_by_admin_id || order.approved_by_user_id),
    id: order.approved_by_admin_id || order.approved_by_user_id || 'N/A',
    name: approverName || 'N/A',
    email: order.approved_by_admin_email || 'N/A'
  }
}

const AdminNotesCard = ({ order, dateFormatter }: ApprovalNotes) => {
  const attribution = approvalAttributionFor(order)

  return (
    <Card className="mb-3">
      <CardHeader style={{ color: 'var(--mf-white)' }}>
        <strong>Admin Notes</strong>
      </CardHeader>
      <CardBody>
        {attribution.hasDetails ? (
          <>
            <p>
              <strong>Admin ID:</strong> {attribution.id}
            </p>
            <p>
              <strong>By Admin:</strong> {attribution.name}
            </p>
            <p>
              <strong>Email:</strong> {attribution.email}
            </p>
            <p>
              <strong>At:</strong> {dateFormatter(order.approved_at)}
            </p>
            <p>
              <strong>Notes:</strong> {order.order_approval_notes}
            </p>
          </>
        ) : (
          <p>This order does not have any admin notes.</p>
        )}
      </CardBody>
    </Card>
  )
}

export default AdminNotesCard
